import React from 'react';
import { TOCItem } from '../pages/HubspotCROGuide';
interface InlineTOCProps {
  items: TOCItem[];
  activeId: string;
  onItemClick: (id: string) => void;
}
export function InlineTOC({
  items,
  activeId,
  onItemClick
}: InlineTOCProps) {
  return <nav className="bg-gray-100 p-6 rounded-lg mb-8" aria-labelledby="toc-heading" data-id="element-73">
      <h2 id="toc-heading" className="text-xl font-bold text-gray-900 mb-4" data-id="element-74">
        Table of Contents
      </h2>
      <ul className="space-y-2" data-id="element-75">
        {items.map(item => <li key={item.id} className={item.level === 3 ? 'ml-4' : ''} data-id="element-76">
            <a href={`#${item.id}`} className={`block py-1 hover:text-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded ${activeId === item.id ? 'text-orange-600 font-medium' : 'text-gray-700'}`} onClick={e => {
          e.preventDefault();
          onItemClick(item.id);
        }} aria-current={activeId === item.id ? 'true' : undefined} data-id="element-77">
              {item.text}
            </a>
          </li>)}
      </ul>
    </nav>;
}